module.exports = __webpack_public_path__ + "img/deco.20ec9158.png";